import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { GameLogo } from '@/components/game/GameLogo';
import { useAuth } from '@/contexts/AuthContext';

interface CompetitionHeaderProps {
  onBack?: () => void;
  isComplete?: boolean;
}

export const CompetitionHeader: React.FC<CompetitionHeaderProps> = ({
  onBack,
  isComplete = false,
}) => {
  const navigate = useNavigate();
  const { iframeParams } = useAuth();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      // Navigate to the appropriate tab based on competition status
      const targetTab = isComplete ? 'recent' : 'play';
      navigate(`/?tab=${targetTab}`);
    }
  };

  return (
    <header
      data-test-id="competition-header"
      className="fixed top-0 left-0 right-0 z-50 bg-app-background p-4 flex items-center justify-between border-b border-border/30"
    >
      <button data-test-id="back-btn" onClick={handleBack} className="text-text-primary">
        <ArrowLeft className="w-6 h-6" />
      </button>
      <GameLogo location={iframeParams.location} className="h-8" />
      <div className="w-6" />
    </header>
  );
};
